export function parseJSONWithFallback<T>(inputString: string, fallback: T) {
  if (inputString) {
    try {
      return JSON.parse(inputString);
    } catch (e) {
      return fallback;
    }
  }
};
